export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "FAQs", to: "/faqs" },
];

export const FOOTER_LINKS = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "FAQs", to: "/faqs" },
  { label: "Track My Order", to: "/track" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
];

export const FAQS = [
  {
    q: "How fresh are your products?",
    a: "Every item is sourced from trusted local suppliers and delivered quickly — never left sitting for days in a warehouse.",
  },
  {
    q: "How do I place an order?",
    a: "Create an account with your name, mobile number and password, add items to your cart, and checkout. Your order details are sent instantly to our team on WhatsApp for quick confirmation.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We currently accept Cash on Delivery (COD) only. Pay conveniently when your order arrives at your doorstep.",
  },
  {
    q: "How can I track my order?",
    a: "Visit the 'Track My Order' page and enter your order number along with the mobile number used while ordering to see live status updates.",
  },
  {
    q: "Do you charge for delivery?",
    a: "Delivery charges depend on your area and are shown at checkout. Orders above a set value may qualify for free delivery.",
  },
  {
    q: "Which areas do you deliver to?",
    a: "We deliver across selected local areas. You can choose your delivery location at checkout to see the applicable charge.",
  },
];

export const SITE = {
  name: "Nicee",
  tagline: "Groceries & essentials, delivered in minutes",
  email: "nicee.raju@gmail.com",
  whatsapp: "917995028255",
  whatsappDisplay: "+91 79950 28255",
  instagram: "https://www.instagram.com/get.nicee?igsh=MW9vaWp0eDVleXc2NQ==",
  pincodes: "502109 & 502110",
};
